export type ToolId =
  | 'lifeRing'
  | 'rope'
  | 'lifeVest'
  | 'rescuePole'
  | 'inflatableBoat'
  | 'autoSalvage';

export interface ToolDefinition {
  id: ToolId;
  key: string;
  name: string;
  shortName: string;
  description: string;
  baseSuccess: number;
  color: number;
  risk: string;
}

export const TOOL_CONFIG: Record<ToolId, ToolDefinition & Record<string, number | string>> = {
  lifeRing: {
    id: 'lifeRing',
    key: 'A',
    name: '救生圈',
    shortName: '圈',
    description: '瞄准、蓄力、松手投掷',
    baseSuccess: 0.72,
    throwSpeed: 15,
    floatStrength: 0.95,
    impactDanger: 0.25,
    safeImpactSpeed: 8,
    color: 0xff6b4a,
    risk: '中等风险',
  },
  rope: {
    id: 'rope',
    key: 'B',
    name: '救生绳',
    shortName: '绳',
    description: '套准身体，再抓住时机收紧',
    baseSuccess: 0.68,
    maxLength: 24,
    safePullForce: 6,
    entangleRisk: 0.22,
    color: 0xffc83d,
    risk: '中等风险',
  },
  lifeVest: {
    id: 'lifeVest',
    key: 'C',
    name: '救生衣',
    shortName: '衣',
    description: '投到身边，按顺序完成穿戴',
    baseSuccess: 0.64,
    floatStrength: 0.9,
    wearDifficulty: 0.35,
    defectRisk: 0.08,
    color: 0xff8f3d,
    risk: '中等风险',
  },
  rescuePole: {
    id: 'rescuePole',
    key: 'D',
    name: '救援杆',
    shortName: '杆',
    description: '伸向目标，稳住方向回拉',
    baseSuccess: 0.84,
    maxReach: 7,
    stability: 0.7,
    color: 0x49a66f,
    risk: '低风险',
  },
  inflatableBoat: {
    id: 'inflatableBoat',
    key: 'E',
    name: '充气小船',
    shortName: '船',
    description: '快速充气，再驾船接近目标',
    baseSuccess: 0.9,
    inflateTime: 5,
    punctureRisk: 0.1,
    color: 0x5d63d8,
    risk: '低风险',
  },
  autoSalvage: {
    id: 'autoSalvage',
    key: 'F',
    name: '自动打捞碟群',
    shortName: '碟',
    description: '一键部署，自动扫描并打捞',
    baseSuccess: 0.88,
    deployTime: 3.2,
    stormInterference: 0.18,
    obstacleInterference: 0.12,
    color: 0x42d5c8,
    risk: '自动救援',
  },
};

export const TOOL_ORDER: ToolId[] = [
  'lifeRing',
  'rope',
  'lifeVest',
  'rescuePole',
  'inflatableBoat',
  'autoSalvage',
];
